/**
 * 根据全部顶级菜单自然宽度计算需要收进“更多”的项目数量。
 * 首项“首页”和末项“更多”始终保留。
 */
export const calculateTopNavMoveCount = (itemWidths: readonly number[], gap: number, availableWidth: number) => {
  const maxMoveCount = Math.max(0, itemWidths.length - 2)

  for (let moveCount = 0; moveCount <= maxMoveCount; moveCount += 1) {
    const visibleWidths = [
      ...itemWidths.slice(0, itemWidths.length - moveCount - 1),
      itemWidths[itemWidths.length - 1] ?? 0,
    ]
    const totalWidth =
      visibleWidths.reduce((sum, itemWidth) => sum + itemWidth, 0) + Math.max(0, visibleWidths.length - 1) * gap

    if (totalWidth <= Math.max(0, availableWidth)) {
      return moveCount
    }
  }

  return maxMoveCount
}
